import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {AuthPref} from './constants';

export const authRequireEmailAsLogin = () =>
	getPublicProperty(AuthPref.FORCE_EMAIL_LOGIN, true);
